import { Button, Form, Input, message } from "antd";
import { LOGIN_TYPE_GA } from "constants/login.constants";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import copy from "copy-to-clipboard";
import { useSetupAuthenticatorModeMutation } from "services/userService";
import { NavigateProfileTab } from "constants/common.constants";

interface SetupGoogleAppProps {
  onSetup: () => void;
}

function SetupGoogleApp(props: SetupGoogleAppProps) {
  const { onSetup } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  //API
  const [setupTwoFaMode, { isLoading, data }] = useSetupAuthenticatorModeMutation();

  useEffect(() => {
    handleSetupTwoFaMode();
  }, []);

  const handleSetupTwoFaMode = () => {
    setupTwoFaMode({ mode: LOGIN_TYPE_GA })
      .unwrap()
      .then((res) => {
        form.setFieldValue("code", res?.data?.code);
      });
  };

  const handleSubmitForm = (value: any) => {};

  const handleCopyCode = () => {
    message.success("Copied to clipboard", 5);
    copy(form.getFieldValue("code"));
  };

  return (
    <Form form={form} onFinish={handleSubmitForm}>
      <div className="setup">
        <h3 className="setup__title">Enable Two-Factor Authentication (2FA)</h3>
        <p className="setup__des">
          Open Google Authenticator or other authenticator app and scan this QR code.
        </p>
        <div
          dangerouslySetInnerHTML={{
            __html: data?.data?.qrCode.slice(data?.data?.qrCode.search("<svg")),
          }}
          className="login__two-factor-qr setup__qr"
        ></div>
        <p className="setup__des">Or enter the following code manually:</p>
        <div className="login__two-factor-group">
          <Form.Item name="code" className="login__two-factor-item">
            <Input className="login__input" />
          </Form.Item>
          <Button
            onClick={handleCopyCode}
            htmlType="button"
            className="login__two-factor-group-btn"
          >
            Copy
          </Button>
        </div>
        <p className="setup__des">
          Once done, you'll start seeing 6-digit verification codes in the app.
        </p>
        <Button onClick={onSetup} className="tableSearch__btn">
          Next
        </Button>

        <div>
          <button
            onClick={() => navigate(`/admin/profile?type=${NavigateProfileTab.TWO_FA_KEY_TAB}`)}
            className="login__process-2fa-back"
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.3327 10H4.66602"
                stroke="#5C1DE9"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.4993 15.8337L4.66602 10.0003L10.4993 4.16699"
                stroke="#5C1DE9"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span className="login__process-2fa-back-text">Back</span>
          </button>
        </div>
      </div>
    </Form>
  );
}

export default SetupGoogleApp;
